import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SectionCompletionForParticipant } from 'app/library/user-section/actions';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import {
    FetchUserSectionStats,
    FetchUserSectionStatsFailure,
    FetchUserSectionStatsForParticipant,
    FetchUserSectionStatsForParticipantFailure,
    FetchUserSectionStatsForParticipantSuccess,
    FetchUserSectionStatsSuccess,
    SectionCompletionForParticipantFailure,
    SectionCompletionForParticipantSuccess,
    SetUserSectionStats,
} from '../actions/index';
import { IModuleCompletionSection } from '../interfaces/module-completion-section.interface';
import { UserSectionStats } from '../models/user-section.model';
import { UserSectionStatsState } from '../models/user-section.state';
import { UserSectionsStatsState } from '../models/user-sections.state';

@Injectable()
export class UserSectionService {
    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    getUserSectionStats(): UserSectionStats[] {
        return this._store.selectSnapshot(UserSectionsStatsState.getFilteredEntities);
    }

    getUserSectionStatsPercentage() {
        return this._store.selectSnapshot(UserSectionsStatsState.getPercentage);
    }

    resetUserSectionStats(): void {
        this._store.dispatch(new SetUserSectionStats([]));
    }

    async fetchUserSectionStats(
        moduleId: string,
        pageSize: number,
        pageNumber: number,
        sortBy?: string,
        sortOrder?: string,
        search?: string,
        status?: string,
        sectionId?: string
    ): Promise<boolean> {
        this._store.dispatch(new FetchUserSectionStats({ moduleId, pageSize, pageNumber, sortBy, sortOrder, search, status, sectionId }));

        return await this._actionHelper.race(FetchUserSectionStatsSuccess, FetchUserSectionStatsFailure).toPromise();
    }

    async fetchUserSectionStatsForParticipant(moduleId: string, participantId: string): Promise<boolean> {
        this._store.dispatch(new FetchUserSectionStatsForParticipant({ moduleId, participantId }));

        return this._actionHelper.race(FetchUserSectionStatsForParticipantSuccess, FetchUserSectionStatsForParticipantFailure).toPromise();
    }

    async bulkSectionCompletion(sections: IModuleCompletionSection[], userId: number): Promise<boolean> {
        this._store.dispatch(new SectionCompletionForParticipant({ sections, userId }));

        return this._actionHelper.race(SectionCompletionForParticipantSuccess, SectionCompletionForParticipantFailure).toPromise();
    }

    getUserSectionStatById(id: string): UserSectionStats {
        return UserSectionStatsState.getEntity(this._store.selectSnapshot(UserSectionStatsState), id);
    }
}
